import React, { useState } from "react";
//import { UserContext }           from '../../../contexts/user';

import Box                 from '@mui/material/Box';
import IconButton          from '@mui/material/IconButton';
import Typography          from '@mui/material/Typography';
import Menu                from '@mui/material/Menu';
import MenuIcon            from '@mui/icons-material/Menu';
import Button              from '@mui/material/Button';
import MenuItem            from '@mui/material/MenuItem';

import Logo                from '../assets/images/overseasEduLogo.png';

const pages                = ['Blog'];

const initialState = {
	nav: false,
};

//<Typography textAlign="center" sx={{color: 'black', fontSize: 'medium'}}>{page}</Typography>
export default function MobileViewContainer () {
	const [{nav}, setState] = useState (initialState);

	const handleNavToggle = (e) => {
		e.preventDefault ();
		setState (prevState => ({ ...prevState, 'nav': !nav }));
	};

	return (
		<>
		<Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
			<IconButton
				size="large"
				aria-label="account of current user"
				aria-controls="menu-appbar"
				aria-haspopup="true"
				onClick={handleNavToggle}
				color="black"
			>
				<MenuIcon />
			</IconButton>
			<Menu
				id="menu-appbar"
				anchorEl={'nav'}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				keepMounted
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				open={nav}
				onClose={handleNavToggle}
				sx={{
					display: { xs: 'block', md: 'none' },
				}}
			>
				{pages.map ((page) => (
					<MenuItem key={page} onClick={handleNavToggle}>
						<Typography textAlign="center"><span className="navItem">{page}</span></Typography>
					</MenuItem>
				))}
			</Menu>
		</Box>
		<Box
			sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} 
			component="img"
			alt="The house from the offer."
			src={Logo}
			style={{width: '60px'}}
		/>
		<Typography
			variant="h5"
			noWrap
			component="a"
			href="/"
			sx={{
				mr: 2,
				display: { xs: 'flex', md: 'none' },
				flexGrow: 1,
				color: 'black',
				textDecoration: 'none',
				fontSize: 'large',
			}}
		>
			<div className='font'>Overseas.one</div>
		</Typography>
		<Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
			{pages.map((page) => (
				<Button
					key={page}
					onClick={() => console.log ("page clicked")}
					sx={{ my: 2, color: 'black', display: 'block', textTransform: 'none', fontSize: 'medium'}}
				>
						<Typography textAlign="center"><span className="navItem">{page}</span></Typography>
				</Button>
			))}
		</Box>
	</>
	);
}
